import React, { forwardRef, useMemo } from 'react'
import { FieldTypes } from 'utils/formUtils';
import ReversingLabSpectraMappingForm from './ReversingLabSpectraMappingForm';
import { urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

const HelpMessage = <div>
    <p>
        By default, the Portal instance will be a subdirectory of <code>my.secure.software</code>.
        Depending on your region, replace <code>my</code> with one of the following:
    </p>
    <ul>
        <li><code>ca</code>, for Canada</li>
        <li><code>us</code>, for USA (interchangeable with <code>my</code>)</li>
    </ul>
</div>

function ReversingLabSpectraCredentialsForm(props, ref) {
    const fields = useMemo(() => (
        [
            {
                name: "organisation",
                label: "Organisation",
                required: true
            },
            {
                name: "apiEndpoint",
                label: "Base URL",
                required: true,
                rules: [urlRegexValidator],
                help: HelpMessage
            }, {
                name: "token",
                label: "API Token",
                type: FieldTypes.PASSWORD,
                required: true
            }]
    ), [])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={ReversingLabSpectraMappingForm}
            initialValue={{ apiEndpoint: 'https://{region}.secure.software' }}
        />
    )
}

export default forwardRef(ReversingLabSpectraCredentialsForm);